import { createSlice } from "@reduxjs/toolkit";
import { getUnitsList, getUnitByID } from "./unitsAction";

const unitSlice = createSlice({
    name: "unit",
    initialState: {
        error: "Sorry! No Data Found.",
        message: null,
        loading: false,        
        unitsLoading: false,
        model: false,
        error_msg: null,
        rowdata: {},
        listCount: 0,
        unitlist: [],
        unitParams: {
            no_of_pages: 0,
            page_size: 10,
            page: 1,
            search: "",
            currentSort: "code",
            sortOrder: "-",
        },
        
    },
    reducers: {
       
        InputChangeValue: (state, action) => {
            return {
                ...state,
                rowdata: {
                    ...state.rowdata,
                    [action.payload.key]: action.payload.value,
                },
            };
        },   
        SetUnitParams: (state, action) => {
            return {
                ...state,
                unitParams: {
                    ...state.unitParams,
                    ...action.payload
                },
            };
        },
        isModelVisible: (state, action) => {
            if (!action.payload) {
                return {
                    ...state,
                    model: action.payload,
                    rowdata: {},
                };
            } else {
                return {
                    ...state,
                    model: action.payload,
                };
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUnitsList.pending, (state, action) => {
                state.status = "getUnitsList loading";
                state.loading = true;
            })
            .addCase(getUnitsList.fulfilled, (state, action) => {
                console.log(action.payload.response)
                state.status = "getUnitsList succeeded";
                state.loading = false;
                var response = action.payload.response;
                var noofpages = Math.ceil(
                    action.payload.count / state.unitParams?.page_size
                );

                state.unitlist = response.results;
                state.listCount = response.count;
                state.unitParams = {
                    ...state.unitParams,
                    no_of_pages: noofpages,
                };
            })
            .addCase(getUnitsList.rejected, (state, action) => {
                state.status = "getUnitsList failed";
                state.loading = false;
                state.error = action.error.message;
            })
            
            .addCase(getUnitByID.pending, (state, action) => {
                state.status = "getUnitByID loading";
                state.loading = true;
            })
            .addCase(getUnitByID.fulfilled, (state, action) => {
                state.status = "getUnitByID succeeded";
                state.loading = false
                state.rowdata = action.payload;
            }
            )
            .addCase(getUnitByID.rejected, (state, action) => {
                state.status = "getUnitByID failed";
                state.loading = false;
                state.error = action.error.message;
            })
           
    }

});
export const {
    InputChangeValue,
    SetUnitParams,
    isModelVisible
} = unitSlice.actions;

export default unitSlice.reducer;